import React, { useState } from "react";
import { Download, RefreshCw } from "lucide-react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const DownloadOptions = ({ chartId, handleRefresh }) => {
  const [downloadDropdownOpen, setDownloadDropdownOpen] = useState(false);

  const toggleDownloadDropdown = () => {
    setDownloadDropdownOpen(!downloadDropdownOpen);
  };

  const handleDownload = async (format) => {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    const canvas = await html2canvas(chartElement);
    const dataUrl = canvas.toDataURL(`image/${format}`);
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `chart-${new Date().toISOString().slice(0, 10)}.${format}`;
    link.click();
    setDownloadDropdownOpen(false);
  };

  const handleExportPDF = async () => {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    const canvas = await html2canvas(chartElement);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    pdf.text("Program Statistics Chart", 105, 15, { align: "center" });
    pdf.addImage(
      imgData,
      "PNG",
      0,
      30,
      210,
      (canvas.height * 210) / canvas.width
    );
    pdf.save(`chart-${new Date().toISOString().slice(0, 10)}.pdf`);
    setDownloadDropdownOpen(false);
  };

  return (
    <div className="ms-auto mx-3 d-flex gap-2 mt-2">
      <div>
        <button onClick={handleRefresh} className="btn" title="Refresh Data">
          <RefreshCw size={15} />
        </button>
      </div>

      <div className="dropdown">
        <button
          className="btn"
          onClick={toggleDownloadDropdown}
          title="Download Chart"
        >
          <Download size={15} />
        </button>

        {downloadDropdownOpen && (
          <ul className="dropdown-menu dropdown-menu-end show">
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleDownload("png")}
              >
                Download as PNG
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleDownload("jpeg")}
              >
                Download as JPEG
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={handleExportPDF}>
                Export as PDF
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default DownloadOptions;
